import React, { useEffect, useState } from "react";
import { Tooltip, Typography } from "antd";
import { brands } from "../../data/data";
import "./BrandsCarousel.scss";

const { Title } = Typography;

const BrandsCarousel = () => {
  const [duplicateLogos, setDuplicateLogos] = useState(false);

  useEffect(() => {
    setDuplicateLogos(true);
  }, []);
  return (
    <section className="logo-carousel">
      <span className="logo-carousel__title manrope f-20 w-700 lh-28 black-085">Trusted by Top Brands & Retailers</span>
      <div className="logo-carousel__container">
        <div className="logo-carousel__track">
          {brands.map((logo, index) => (
            <div key={`${logo.name}-${index}`} className="logo-carousel__item">
              <Tooltip title={<span className="manrope f-12 white">{logo.name}</span>}>
                <img height={logo.height} src={logo.path} alt={`${logo.name} logo`} />
              </Tooltip>
            </div>
          ))}
          {duplicateLogos &&
            brands.map((logo, index) => (
              <div
                key={`${logo.name}-duplicate-${index}`}
                className="logo-carousel__item"
              >
                <Tooltip title={<span className="manrope f-12 white">{logo.name}</span>}>
                  <img  height={logo.height} src={logo.path} alt={`${logo.name} logo`} />
                </Tooltip>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default BrandsCarousel;
